import {useTranslation} from "react-i18next";
import i18n from "i18next";

import {chartsRoutes} from "../../../common/app/routing/charts_routes";
import {Price} from "./Price";
import {PricingBoxBase} from "./PricingBoxBase";

interface IProps {
    isRpClient: boolean;
}

const SUBSCRIPTION_PRICES = {
    standard: "2900",
    rpClient: "1900"
};

export const MonitoringPricingBox = ({isRpClient}: IProps) => {
    const {t} = useTranslation();
    const price = SUBSCRIPTION_PRICES[isRpClient ? "rpClient" : "standard"];
    const title = (
        <>
            {t("pricing.monitoring_subscription.description_1")}
            <br />
            {t("pricing.monitoring_subscription.description_2")}
        </>
    );

    return (
        <PricingBoxBase title={title}>
            <Price
                isMonitoring
                price={price}
                primaryButton={{text: t("pricing.order"), href: "#contact"}}
                secondaryButton={{text: t("pricing.learn_more"), href: chartsRoutes[i18n.language].monitoring.root}}
            />
        </PricingBoxBase>
    );
};
